import { HTTP } from '../../http';
import router from '../../router/index';

const state = {
  brandList: JSON.parse(localStorage.getItem('exideBrandList')) || [],
  modelTypes: [],
  activeBrand: null,
  brandListLoadingStatus: true
};
const getters = {
  getBrandsList: state => state.brandList,
  getModelTypes: state => state.modelTypes,
  getActiveBrand: state => state.activeBrand,
  getBrandListLoadingStatus: state => state.brandListLoadingStatus
};
const mutations = {
  setBrandList: (state, list) => {
    state.brandList = list;
  },
  setActiveBrand: (state, brand) => {
    state.activeBrand = brand;
  },
  setModelTypes: (state, list) => (state.modelTypes = list),
  setBrandListLoadingStatus: (state, status) => (state.brandListLoadingStatus = status)
};
const actions = {
  fetchModelsList: ({ commit, state }) => {
    commit('setBrandListLoadingStatus', true);
    HTTP.get(`/api/batteries?vehicleType=${window.localStorage.exideVehicleType}`)
      .then(response => {
        commit('setBrandListLoadingStatus', false);
        commit('setBrandList', response.data);
      })
      .catch(error => {
        commit('setBrandList', []);
        commit('setBrandListLoadingStatus', false);
      });
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};
